export default {
  headerContent: {
    title: 'Türk Nippon Sigorta Tamamlayıcı Sağlık Sigortası Teklifi',
    slogan: "Tamamlayıcı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TAMAMLAYICI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'Türk Nippon Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Tamamlayıcı sağlık sigortası sosyal güvencesi bulunan bireylerin özel hastanelerde tedavi hizmeti almalarını sağlamaktadır.',
        'Türk Nippon Sigorta tamamlayıcı sağlık sigortası SGK ile anlaşmalı özel hastaneler kaza veya hastalık sonucu alınması gereken tedavi hizmeti sonucunda oluşan maddi giderlere karşı koruma sağlamaktadır.',
        'İhtiyaçlarınıza ve bütçenize uyacak şekilde farklı kapsama seviyelerine sahip çeşitli sağlık sigortası planları arasından seçim yapabilirsiniz. Sağlık bakımı maliyetleri yaşınıza ve içinde yaşadığınız duruma göre değişir. Beklediğiniz gibi, daha genç ve sağlıklı yetişkinler sağlık sigortası için en az ücreti öderler. Bununla birlikte, daha genç yetişkinler için bile, kapsamın maliyeti coğrafi konuma göre büyük ölçüde değişir.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Sağlığınız Bizde Tamamlayıcı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası teminatları yatarak, ayakta ve doğum olmak üzere 3’e ayrılmaktadır. ',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Cerrahi ve dâhili yatışlar',
            'Yoğun bakım',
            'Kemoterapi',
            'Radyoterapi',
            'Diyaliz',
            'Küçük müdahale',
            'Koroner anjiyografi',
            'Standart tek kişilik özel oda, yemek ve refakatçi giderleri',
            'Ameliyat sonrası fizik tedavi',
            'Evde Bakım ',
            'Suni Uzuv ',
            'Yardımcı Tıbbi Malzeme'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Ayakta Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Doktor Muayene',
            'Laboratuvar',
            'İleri tanı yöntemleri',
            'Radyoloji',
            'Fizik Tedavi'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türk Nippon Sigorta Tamamlayıcı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
